import { captureException } from '@sentry/react';
import { StateCreator } from 'zustand';

import { queryClient } from '@/clients';
import {
    fetchPrefetchedDetailQuery,
    getPrefetchedDetailQueryData,
    searchCompanyDetailQueryOptions,
} from '@/queries/tanstack/prefetch';

import { CompanyActions, CompanyState } from '../types';

export const createCompanyActions: StateCreator<
    CompanyState & CompanyActions,
    [['zustand/immer', never]],
    [],
    CompanyActions
> = (set, get, store) => ({
    fetchCompanyByTickerSymbol: async (tickerSymbol) => {
        const queryOptions = searchCompanyDetailQueryOptions.profile(tickerSymbol);
        const cachedCompany = getPrefetchedDetailQueryData(queryClient, queryOptions);

        set({
            loadingCompany: !cachedCompany,
            error: undefined,
            ...(cachedCompany ? { selectedCompany: cachedCompany } : {}),
        });

        try {
            const company = await fetchPrefetchedDetailQuery(queryClient, queryOptions);

            set((state) => {
                state.selectedCompany = company;
                state.loadingCompany = false;
            });
        } catch (error) {
            captureException(error);

            set((state) => {
                state.error = 'Failed to fetch company detail';
                state.loadingCompany = false;
            });
        }
    },
    clearSelectedCompany: () => {
        set((state) => {
            state.selectedCompany = null;
        });
    },
    // - Aliases
});
